import AudioWave from './AudioWave';

export default AudioWave;
